module.exports = __webpack_public_path__ + "img/xh.1ded1f87.png";